export default __webpack_public_path__ + "static/media/placeholder-image-featured.94a437f5.svg";